var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTopPerformDummyProf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5011 17.5C13.6214 17.5 10.4679 14.3605 10.4679 10.5C10.4679 6.63947 13.6214 3.49997 17.5011 3.49997C21.3809 3.49997 24.5344 6.63947 24.5344 10.5C24.5344 14.3605 21.3809 17.5 17.5011 17.5ZM24.1091 18.6777C25.5551 17.5263 26.6702 16.0124 27.3409 14.2901C28.0116 12.5677 28.2141 10.6984 27.9276 8.87237C27.2329 4.28213 23.3969 0.608959 18.7646 0.0734594C12.3736 -0.66679 6.95215 4.28572 6.95215 10.5C6.95215 13.8075 8.49215 16.7544 10.8931 18.6777C4.99215 20.8844 0.683654 26.0662 0.00815426 33.0592C-0.0154638 33.3044 0.0123613 33.552 0.0898383 33.7859C0.167315 34.0198 0.292746 34.2349 0.458111 34.4176C0.623475 34.6003 0.825132 34.7463 1.05019 34.8466C1.27525 34.9468 1.51877 34.9991 1.76516 34.9999C2.19705 35.0034 2.61466 34.8455 2.93612 34.5571C3.25759 34.2687 3.45973 33.8704 3.5029 33.4407C4.20815 25.6305 10.2159 21 17.5011 21C24.7864 21 30.7941 25.6305 31.4994 33.4407C31.5425 33.8704 31.7447 34.2687 32.0662 34.5571C32.3876 34.8455 32.8052 35.0034 33.2371 34.9999C34.2801 34.9999 35.0921 34.0934 34.9924 33.0592C34.3186 26.0662 30.0101 20.8844 24.1074 18.6777",
    fill: "#F2E9E9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopPerformDummyProf);
export default __webpack_public_path__ + "static/media/top_perform_dummy_prof.1903e3e5c4920d383fdca618c886713b.svg";
export { ForwardRef as ReactComponent };